/*
 * THE COOKIE NOTICE'S HEIGHT (bar-above-notice, owner, 8 Oct 2026). Nothing
 * the shop fixes to the bottom of the screen may sit under CookieYes's notice:
 * while it shows, each sits directly above it, and when it goes each returns
 * to its place. This publishes how much of the bottom edge the notice takes as
 * --dg-cookie-notice-height on the root, 0px when it is not showing; dg-shop.css
 * offsets the purchase bar, the menu's round control and the open menu's foot
 * by it, and dg-product.js adds it to the page's bottom padding.
 *
 * MEASURED, NEVER TYPED. The notice arrives late and asynchronously, changes
 * height with the viewport, and differs between CookieYes's US banner (about
 * 88px at 1280, 135 at 375) and its EU one (152 and 316). So this watches the
 * body for the notice being added or removed, the notice's class and style
 * for it being shown or hidden, and its box for any resize, and re-measures on
 * each. The height is its box's height plus its bottom offset, rounded up to
 * the pixel, not its top edge, so an entrance that slides it in does not drag
 * the bar along. A notice not pinned to the bottom edge counts as 0.
 *
 * CookieYes's markup, styles and z-index are not touched.
 */
(() => {
  const NAME = '--dg-cookie-notice-height';
  const SELECTOR = '.cky-consent-container';
  const root = document.documentElement;
  let notice = null;
  let last = '';

  function height() {
    if (!notice?.isConnected) return 0;
    const style = getComputedStyle(notice);
    if (style.display === 'none' || style.visibility === 'hidden' || style.position !== 'fixed') return 0;
    const bottom = Number.parseFloat(style.bottom);
    if (!Number.isFinite(bottom)) return 0;
    // Its box is fractional (88.4px at 1280), so round up: never under it.
    return Math.max(0, Math.ceil(notice.getBoundingClientRect().height + bottom));
  }

  function publish() {
    const value = `${height()}px`;
    if (value === last) return;
    last = value;
    root.style.setProperty(NAME, value);
    document.dispatchEvent(new CustomEvent('dg:notice'));
  }

  const sizes = new ResizeObserver(publish);
  const states = new MutationObserver(publish);

  function find() {
    const found = document.querySelector(SELECTOR);
    if (found !== notice) {
      if (notice) sizes.unobserve(notice);
      states.disconnect();
      notice = found;
      if (notice) {
        sizes.observe(notice);
        states.observe(notice, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      }
    }
    publish();
  }

  new MutationObserver(find).observe(document.body, { childList: true });
  window.addEventListener('resize', publish);
  find();
})();
